import { styled } from '@linaria/react';

export const StyledQuotesCarousel = styled.div`
	display: flex;
	overflow: hidden;
	width: 100%;
	flex-direction: column;
	align-items: center;
	padding-bottom: 0.8rem;
	gap: 1.4rem;
`;
export const Wrapper = styled.div`
	display: flex;
	overflow: visible;
	width: 100%;
	flex-grow: 1;
	gap: var(--gap-x5);
	transition: transform 0.3s;
`;

export const Card = styled.div`
	display: flex;
	width: 100%;
	flex-shrink: 0;
	padding: 2rem 2.4rem;
	border-radius: var(--radius-s);
	backdrop-filter: blur(12.5px);
	background-color: var(--color-white-xxs);
`;

export const Progress = styled.div`
	display: flex;
	gap: 0.7rem;
`;

export const ProgressItem = styled.div<{ timeout: number }>`
	overflow: hidden;
	width: 0.6rem;
	height: 0.6rem;
	border-radius: var(--radius-m);
	background-color: var(--color-white-m);

	@keyframes fill {
		0% {
			width: 0.6rem;
		}
		100% {
			width: 6.4rem;
		}
	}

	& div {
		height: 100%;
		border-radius: var(--radius-m);
	}

	&.active {
		width: 6.4rem;
		& div {
			animation: fill ${({ timeout }) => timeout}ms linear forwards;
			background-color: white;
		}
	}
`;
